import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IBaseResponse, 
  IOpcionVariable, 
  IEnviarMensajeRequest, 
  IBuscarMensajesRequest,
  IMensajeNotificaRequest,
  IMensajeNotificaResponse,
  IMensajeEnviadoResponse,
  IUsuarioRequest,
  IUsuarioResponse,
  IEnviarMensajeNotifica1Request,
  IEnviarMensajeNotifica1Response
} from '../interfaces/centro-mensajes.interface';

@Injectable({
  providedIn: 'root'
})
export class CentroMensajesService {
  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) {}

  getOpcionesVariables(tabla: string, campo: string): Observable<IBaseResponse<IOpcionVariable>> {
    return this.http.post<IBaseResponse<IOpcionVariable>>(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, {
      sTabla: tabla,
      sCampo: campo,
      iIdioma: 0
    });
  }

  enviarMensaje(request: IEnviarMensajeRequest): Observable<IBaseResponse<any>> {
    return this.http.post<IBaseResponse<any>>(`${this.apiUrl}/CentroMensajes/EnviarMensaje`, request);
  }

  buscarMensajes(request: IBuscarMensajesRequest): Observable<IBaseResponse<any>> {
    return this.http.post<IBaseResponse<any>>(`${this.apiUrl}/CentroMensajes/BuscarMensajes`, request);
  }

  getMensajesNotificados(request: IMensajeNotificaRequest): Observable<IMensajeNotificaResponse> {
    return this.http.post<IMensajeNotificaResponse>(`${this.apiUrl}MensajeriainCS/GetMensjNotifica2`, request);
  }

  getMensajesEnviados(request: IMensajeNotificaRequest): Observable<IMensajeEnviadoResponse> {
    return this.http.post<IMensajeEnviadoResponse>(`${this.apiUrl}MensajeriainCS/GetMensjNotifica4`, request);
  }

  getUsuarios(): Observable<IUsuarioResponse> {
    const request: IUsuarioRequest = {
      tope: "99999",
      usuario: ""
    };
    return this.http.post<IUsuarioResponse>(`${this.apiUrl}UsuarsCS/Getcmspa_usua4`, request);
  }

  enviarMensajeNotifica1(request: IEnviarMensajeNotifica1Request): Observable<IEnviarMensajeNotifica1Response> {
    return this.http.post<IEnviarMensajeNotifica1Response>(`${this.apiUrl}MensajeriainCS/GetMensjNotifica1`, request);
  }
} 